
import { Component, Prop, Vue } from 'vue-property-decorator';
import { types } from '../../api_types';
import T from '../../lang';
import * as ui from '../../ui';

import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faBan,
  faBookmark,
  faEdit,
  faExclamationTriangle,
  faExternalLinkAlt,
  faEyeSlash,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
library.add(
  faExclamationTriangle,
  faEdit,
  faEyeSlash,
  faBan,
  faExternalLinkAlt,
  faBookmark,
);

@Component({
  components: {
    FontAwesomeIcon,
  },
})
export default class ProblemSettingsSummary extends Vue {
  @Prop() problem!: types.ArenaProblemDetails;
  @Prop({ default: null }) problemsetTitle!: null | string;
  @Prop({ default: false }) showVisibilityIndicators!: boolean;
  @Prop({ default: false }) showEditLink!: boolean;
  @Prop({ default: false }) userLoggedIn!: boolean;
  @Prop({ default: false }) isBookmarked!: boolean;
  @Prop({ default: false }) inContestOrCourse!: boolean;

  T = T;

  onToggleBookmark(): void {
    this.$emit('toggle-bookmark', this.problem.alias);
  }

  get title(): string {
    if (this.showVisibilityIndicators) {
      return ui.formatString(T.problemSettingsSummaryTitleWithProblemId, {
        problem_id: this.problem.problem_id,
        problem_title: this.problem.title,
      });
    }
    if (this.problem.letter && this.problemsetTitle) {
      return ui.formatString(
        T.problemSettingsSummaryTitleWithProblemsetTitleAndLetter,
        {
          problemset_title: this.problemsetTitle,
          letter: this.problem.letter,
          problem_title: this.problem.title,
        },
      );
    }
    if (this.problem.letter && !this.problemsetTitle) {
      return ui.formatString(T.problemSettingsSummaryTitleWithLetter, {
        letter: this.problem.letter,
        problem_title: this.problem.title,
      });
    }
    return this.problem.title;
  }

  get memoryLimit(): string {
    if (!this.problem.settings?.limits.MemoryLimit) {
      return '';
    }
    if (typeof this.problem.settings?.limits.MemoryLimit === 'string') {
      return this.problem.settings?.limits.MemoryLimit;
    }
    const memoryLimit = this.problem.settings?.limits.MemoryLimit as number;
    return `${memoryLimit / 1024 / 1024} MiB`;
  }

  get timeLimit(): string {
    if (!this.problem.settings?.limits.TimeLimit) {
      return '';
    }
    return `${this.problem.settings?.limits.TimeLimit}`;
  }

  get overallWallTimeLimit(): string {
    if (!this.problem.settings?.limits.OverallWallTimeLimit) {
      return '';
    }
    return `${this.problem.settings?.limits.OverallWallTimeLimit}`;
  }

  get inputLimit(): string {
    if (!this.problem.input_limit) {
      return '';
    }
    return `${this.problem.input_limit / 1024} KiB`;
  }

  get warningReasons(): string[] {
    return this.problem.warningReasons ?? [];
  }

  get showWarningReasons(): boolean {
    // Only show warning reasons when visibility indicators are active
    // (which means the user is viewing their own problem details)
    return this.showVisibilityIndicators;
  }

  get isBanned(): boolean {
    // visibility <= -2 indicates banned status
    return this.problem.visibility <= -2;
  }
}
